import { useParams, useNavigate } from 'react-router-dom'
import LegalDocContent, { getLegalDocTitle } from '../components/LegalDocContent'
import './onboarding/onboarding.css'

const TERMS_PDF_URL = '/legal/terms-and-conditions.pdf'

const PublicLegalDoc = () => {
  const { docId } = useParams()
  const navigate = useNavigate()
  const title = getLegalDocTitle(docId) || 'Document'

  const isTerms = docId === 'terms-and-conditions'

  return (
    <div className="onboarding-page">
      <div className="onboarding-content" style={{ paddingTop: 32, paddingBottom: 48 }}>
        <div style={{ marginBottom: 16 }}>
          <button type="button" className="link" onClick={() => navigate(-1)}>← Back</button>
        </div>
        <h1 className="h1" style={{ marginBottom: 16 }}>{title}</h1>

        {isTerms ? (
          <div style={{ maxHeight: '70vh', overflow: 'hidden', borderRadius: 8, border: '1px solid rgba(0,0,0,0.08)' }}>
            <iframe
              src={TERMS_PDF_URL}
              title={title}
              style={{ width: '100%', height: '70vh', border: 'none' }}
            />
            <p className="p" style={{ marginTop: 12 }}>
              If the document doesn&apos;t load,{' '}
              <a href={TERMS_PDF_URL} target="_blank" rel="noreferrer">
                open it in a new tab
              </a>
              .
            </p>
          </div>
        ) : (
          <LegalDocContent docId={docId} />
        )}
      </div>
    </div>
  )
}

export default PublicLegalDoc

